import Newvendorform from './new_vendor_form.vue'
import VendorDetail from './vendor-detail.vue'
export default{
    Newvendorform,
    'vendor-detail': VendorDetail
}